module.exports = __webpack_public_path__ + "img/xero-inactive-even-line.9169084e.svg";